<template>
  <section class="growth-hero">
    <div class="growth-hero__copy">
      <p class="growth-eyebrow">
        <span class="growth-live-dot" />{{ $t('refresh.hero-kicker') }}
      </p>
      <h1>
        {{ $t('refresh.hero-title') }}<br><span>{{ $t('refresh.hero-accent') }}</span><span
          class="growth-title-star"
          aria-hidden="true"
        >✳</span>
      </h1>
      <p class="growth-hero__description">
        {{ $t('refresh.hero-description') }}
      </p>
      <div class="growth-hero__actions tw:flex tw:flex-wrap tw:gap-3">
        <router-link
          to="/auth/signup"
          class="growth-button growth-button--lime growth-button--large"
        >
          {{ $t('refresh.start-free') }}<GrowthIcon name="up" />
        </router-link>
        <a
          href="#grow"
          class="growth-text-link"
        >{{ $t('refresh.see-how') }}<GrowthIcon name="arrow" /></a>
      </div>
      <p class="growth-hero__note">
        <GrowthIcon name="check" />{{ $t('refresh.hero-note') }}
      </p>
    </div>
    <div class="growth-hero__visual">
      <img
        src="/images/upgrade-bg.jpg"
        :alt="$t('refresh.hero-image')"
        class="growth-stage-photo"
        width="1536"
        height="1024"
        fetchpriority="high"
      >
      <div class="growth-photo-caption">
        <span>{{ $t('refresh.independent') }}</span><span>01 / ∞</span>
      </div>
      <div
        class="growth-visual-word"
        aria-hidden="true"
      >
        {{ $t('refresh.art-line-one') }}<br>{{ $t('refresh.art-line-two') }}
      </div>
      <div class="growth-audience-note">
        <span class="growth-audience-note__icon"><GrowthIcon name="people" /></span><div><strong>{{ $t('refresh.next-fan') }}</strong><span>{{ $t('refresh.next-fan-note') }}</span></div><GrowthIcon name="up" />
      </div>
      <span class="growth-photo-sticker"><GrowthIcon name="globe" /><span>{{ $t('refresh.made-independent') }}</span></span>
    </div>
    <div class="growth-platform-strip">
      <span>{{ $t('refresh.everywhere') }}</span>
      <div><span>Spotify</span><span>Apple Music</span><span>YouTube Music</span><span>TikTok</span><span>Amazon Music</span><span>Deezer</span></div>
    </div>
  </section>
</template>
<script setup>
import GrowthIcon from '@/components/growth/GrowthIcon.vue';
</script>
